import React from 'react';
import {MDBModal, MDBModalBody, MDBModalHeader} from "mdbreact";
import {Col, Row} from "reactstrap";
import {Button, Form} from "semantic-ui-react";
import TxtLbl from "../../../components/Input/Input/TxtLbl";
import TxtAreaLbl from "../../../components/Input/TextArea/TextAreaLbl";
import * as common from "../../../const/Common/CommonFunc";
import 'semantic-ui-css/semantic.min.css';
import './updateUserGroupStyles.scss';
import swal from "sweetalert";
import are_you_sure_icon from "../../../assets/img/sweet/question.svg";
import Cookies from "js-cookie";
import axios from "../../../axios/axios_tag";
import apiConfig from "../../../axios/axios_api_services";
import * as actionCreator from "../../../store/Action";
import {connect} from "react-redux";

class UpdateUserGroupModal extends React.Component {

  state = {
    userGroupId: 0,
    corporateId: 0,
    corporateName: null,
    createdBy: null,
    createdDate: "",
    modifyDate: "",
    modufyBy: null,
    status: 0,


    real_groupDesc: null,
    real_groupName: null,

    edit_groupDesc: null,
    edit_groupName: null,

  };

  toggle = () => {};


  componentDidMount() {
    let userGroup = this.props.userGroup;
    let corporateName = this.props.corporateName;

    if(userGroup) {
      this.setState({
        userGroupId: userGroup.userGroupId,
        corporateId: userGroup.corporateId,
        corporateName: corporateName,

        createdBy: userGroup.createdBy,
        createdDate: userGroup.createdDate,
        modifyDate: userGroup.modifyDate,
        modufyBy: userGroup.modufyBy,
        status: userGroup.status,

        real_groupDesc: userGroup.groupDesc,
        real_groupName: userGroup.groupName,
        edit_groupDesc: userGroup.groupDesc,
        edit_groupName: userGroup.groupName,
      });
    }
  }

  onChangeUserGroupName = event => {
    let value = event.target.value;
    this.setState({
      edit_groupName: value
    });
  };

  onChangeUserGroupDesc = event => {
    let value = event.target.value;
    this.setState({
      edit_groupDesc: value
    });
  };

  updateUserGroup=()=>{
    this.state.edit_groupName === ""?common.notifyMessage("User group name can't be empty") :
      this.state.edit_groupDesc === ""?common.notifyMessage("User group description can't be empty") :
        this.updateUserGroup_();
  };

  updateUserGroup_=()=>{
    swal({
      title: "Do you want to proceed?",
      icon: are_you_sure_icon,
      closeOnClickOutside: false,
      buttons: {
        cancel: 'Cancel',
        dangerMode: {
          text: "Yes",
          value: "action",
          className: "okay-btn"
        }
      },
    })
      .then((value) => {
        switch (value) {
          case "action":
            this.sendToBackend();
            break;
          default:
        }
      });

  };

  sendToBackend = () => {
    let obj = {
      userGroupId: this.state.userGroupId,
      corporateId: this.state.corporateId,
      groupName: this.state.edit_groupName,
      groupDesc: this.state.edit_groupDesc,
      users : [],
      status: this.state.status,
    };

    const headers = {
      "Authorization": "Bearer " + Cookies.get("68a6102f6ed24899420170004a0273b8")
    };
    this.props.spinnerHandler(true);
      axios.post(apiConfig.UPDATE_CORPORATE_USER_GROUP,obj,{headers:headers}).then(r =>{
        if(r.status === 200) {
          if(r.data.success) {
            this.setState({
              real_groupDesc: r.data.groupDesc,
              real_groupName: r.data.groupName,
            });
            common.warningAlert(this.state.edit_groupName + " user group had updated successfully!", 0);
          } else {
            common.warningAlert("Something went wrong!", 1)
          }
        }
      }).catch(async error => {
        let result = await common.checkErrorResponse(error);
        if (result === 1) {
          this.sendToBackend();
        }
      }).finally(fin => {
        this.props.spinnerHandler(false);
      });

  };

  render() {

    let {
      userGroupId,
      corporateId,
      corporateName,
      real_groupDesc,
      real_groupName,
      edit_groupDesc,
      edit_groupName
    } = this.state;

    let button_disable = true;

    if(edit_groupName!=="" && edit_groupDesc!=="") {
      if(real_groupName!==edit_groupName || real_groupDesc!==edit_groupDesc) {
        button_disable = false;
      } else {
        button_disable = true;
      }
    } else {
      button_disable = true;
    }
    return(
      <div>
          <MDBModal isOpen={this.props.isOpen} toggle={this.toggle} size="md">
            <MDBModalHeader className={"title"}
                            toggle={this.props.closeModal}>Update User Group Details</MDBModalHeader>
            <MDBModalBody>
              <div className={'update-form'}>
                <Form>
                  <Form.Field>
                    <label>Corporate</label>
                    <input
                      placeholder='Corporate Name'
                      value={corporateName}
                      disabled={true}
                    />
                  </Form.Field>
                  <Form.Field>
                    <label>User Group Name</label>
                    <input
                      placeholder='User Group Name'
                      onChange={this.onChangeUserGroupName}
                      value={ edit_groupName }
                    />
                  </Form.Field>
                  <Form.Field>
                    <Form.TextArea
                      label='User Group Description'
                      placeholder='Tell us more about you...'
                      onChange={this.onChangeUserGroupDesc}
                      value={ edit_groupDesc }
                    />
                  </Form.Field>
                  <Form.Field className={'text-right'}>
                    <Button className="px-5" disabled={button_disable} onClick={this.updateUserGroup}>Update</Button>
                  </Form.Field>
                </Form>
              </div>
            </MDBModalBody>
          </MDBModal>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    spinnerHandler: (data) => dispatch(actionCreator.spinnerHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(UpdateUserGroupModal);
